export default "__VITE_ASSET__0ac09da3__"